if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');

        if (!this.form) return;

        const variantInput = this.form.querySelector('[name="id"]');

        if (variantInput) {
          variantInput.disabled = false;
        }

        this.form.addEventListener(
          'submit',
          this.onSubmitHandler.bind(this)
        );

        // Support both Shopify cart types
        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        const submitButton = this.querySelector('[type="submit"]');
        const spinner = this.querySelector('.loading-overlay__spinner');

        if (!submitButton) return;

        if (submitButton.classList.contains('loading')) return;

        this.handleErrorMessage();

        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');

        if (spinner) {
          spinner.classList.remove('hidden');
        }

        // Save active element only if supported
        if (
          this.cart &&
          typeof this.cart.setActiveElement === 'function'
        ) {
          this.cart.setActiveElement(document.activeElement);
        }

        const config = fetchConfig('javascript');

        config.headers['X-Requested-With'] = 'XMLHttpRequest';

        const formData = {
          ...JSON.parse(serializeForm(this.form))
        };

        // Only request Shopify sections if a cart component exists
        if (
          this.cart &&
          typeof this.cart.getSectionsToRender === 'function'
        ) {
          formData.sections = this.cart
            .getSectionsToRender()
            .map((section) => section.id);

          formData.sections_url = window.location.pathname;
        }

        config.body = JSON.stringify(formData);

        fetch(routes.cart_add_url, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(
                response.description || 'Unable to add this item to cart.'
              );

              return;
            }

            // Render cart drawer / notification
            if (
              this.cart &&
              typeof this.cart.renderContents === 'function'
            ) {
              this.cart.renderContents(response);
            } else {
              // Fallback if theme has no AJAX cart UI
              window.location.href = routes.cart_url || '/cart';
            }
          })
          .catch((error) => {
            console.error('Add to cart error:', error);

            this.handleErrorMessage(
              'Something went wrong. Please try again.'
            );
          })
          .finally(() => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');

            if (spinner) {
              spinner.classList.add('hidden');
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper');

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute(
          'hidden',
          !errorMessage
        );

        if (errorMessage && this.errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}